<template>
  <div class="d-flex pt-4 pb-4">
    <div class="d-flex ml-auto">
      <div
        v-b-tooltip.hover
        :title="
          invalid && getCustomRulesIgnoreMessage
            ? resource['label.Enter.RequiredFields']
            : ''
        "
      >
      <button
        v-if="(tabIndex === 0 && pageType === 'interview')"
        id="lastStepSaveBtnTwoBack"
        name="lastStepSaveBtnTwoBack"
        class="btn lg bg-transparent border-purple mr-2 text-purple firs-button"
        @click="goToTypeStep()"
      >
      {{ resource['hrvenue.interviewButtonBack'] }}
      </button>
      <button
      v-if="(tabIndex === 0)"
      id="lastStepSaveBtnOne"
      name="lastStepSaveBtnOne"
      class="btn lg bg-purple text-white single-button"
      :class="{'disabled' : invalid}"
      :disabled="publishLoader || invalid"
      @click="checkAction('continue')"
    >
      {{ resource['hrvenue.interviewButton'] }}
    </button>

    <button
          v-if="(tabIndex === 1)"
          id="lastStepSaveBtnTwoBack"
          name="lastStepSaveBtnTwoBack"
          class="btn lg bg-transparent border-purple mr-2 text-purple firs-button"
          @click="checkAction('back')"
        >
        {{ resource['hrvenue.interviewButtonBack'] }}
        </button>

        <button
          v-if="(tabIndex === 1)"
          id="lastStepSaveBtnTwo"
          name="lastStepSaveBtnTwo"
          class="btn lg bg-purple text-white second-button"
          :class="{'disabled' : invalid}"
          :disabled="publishLoader || invalid"
          @click="checkAction('continue')"
        >
          {{ resource['hrvenue.interviewButton'] }}
        </button>

        <button
          v-if="pageType === 'interview' && interviewType === 1 && tabIndex === 2"
          id="lastStepSaveBtnTwoBack"
          name="lastStepSaveBtnTwoBack"
          class="btn lg bg-transparent border-purple mr-2 text-purple first-button"
          @click="checkAction('back')"
        >
          {{ resource['hrvenue.interviewButtonBack'] }}
        </button>

        <button
          v-if="pageType === 'interview' && interviewType === 1 && tabIndex === 2"
          id="lastStepSaveBtnTwo"
          name="lastStepSaveBtnTwo"
          class="btn lg bg-purple text-white second-button"
          @click="checkAction('continue')"
        >
          {{ resource['hrvenue.interviewButton'] }}
        </button>

        <button
          v-if="(pageType === 'interview' && interviewType === 1 && tabIndex === 3) || ((pageType === 'question' || interviewType === 3) && tabIndex === 2)"
          id="lastStepSaveBtnThreeBack"
          name="lastStepSaveBtnThreeBack"
          class="btn lg bg-transparent border-purple mr-2 text-purple first-button"
          @click="checkAction('back')"
        >
          {{ resource['hrvenue.interviewButtonBack'] }}
        </button>

        <button
          v-if="(pageType === 'interview' && interviewType === 1 && tabIndex === 3) || ((pageType === 'question' || interviewType === 3) && tabIndex === 2)"
          class="btn lg bg-purple text-white second-button"
          id="lastStepSaveBtnThree"
          name="lastStepSaveBtnThree"
          :class="{'disabled' : invalid}"
          :disabled="publishLoader || invalid"
          @click="checkAction(getCheckActionType)"
        >
          <i
            v-if="publishLoader"
            class="icon-sync icon-spin"
            width="40"
            height="40"
          />
          {{ resource['label.Save'] }}
        </button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.btn {
  &.disabled{
    background: #C2C2C2 !important;
    opacity: 1 !important;
  }
}
</style>
<script>
export default {
  name: 'InterviewActionBar',

  props: {
    tabIndex: {
      type: Number,
      required: true,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    loadingStack: {
      type: Object,
      default: () => ({}),
    },
    interviewType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      pageType: '',
    };
  },

  created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
  },

  computed: {
    getContinueButtonText() {
      if (this.tabIndex === 1) {
        return this.resource['hrvenue.interviewButton'];
      }
      if (this.tabIndex === 2) {
        return this.resource['hrvenue.interviewSkipPreview'];
      }
      return this.resource['hrvenue.interviewButton'];
    },

    getSaveButtonText() {
      if (this.tabIndex === 1) {
        return this.resource['hrvenue.interviewButton'];
      }
      if (this.tabIndex === 2) {
        return this.resource['hrvenue.interviewSkipPreview'];
      }
      return this.resource['hrvenue.interviewButton'];
    },

    publishLoader() {
      return (
        this.loadingStack.publishNewJob
        || this.loadingStack.publishExistingJob
        || this.loadingStack.publishExistingClosingDateExpiredJob
      );
    },
    getCheckActionType() {
      return !this.isEdit ? 'save' : 'edit';
    },
  },

  methods: {
    checkAction(val) {
      this.$emit('check-action', val);
    },

    getCustomRulesIgnoreMessage() {
      if (this.pageType === 'question') {
        return !(this.tabIndex === 1);
      }
      if (this.pageType === 'interview') {
        return !(this.tabIndex === 2);
      }
    },
    goToTypeStep() {
      this.$emit('update:tabIndex', -1);
    },
  },
};
</script>
